import React, { } from "react";
import { Button } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useHistory, useLocation } from "react-router-dom";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { documentLabelPanelAction } from "../../../context/actions/documentLabelPanelAction";
import "../index.scss";

const SideBar = () => {
    let history = useHistory();
    const location = useLocation();
    const documentLabelPanelOnState = useSelector(state => state.documentLabelPanelReducer.documentLabelPanelOn);
    const dispatch = useDispatch();

    const documentLabelPanelHandler = () => {
        dispatch(documentLabelPanelAction(!documentLabelPanelOnState))
    }
    const overlayHandler = () => {
        dispatch(documentLabelPanelAction(false))
    }
    const handleClick = (url) => {
        history.push(url)
    }
    return (



        // <div className="page-header d-flex">
        //     <div className="left-colum">
        //         <Button
        //             color="link"
        //             className="term-panel-btn"
        //             onClick={documentLabelPanelHandler}>
        //             <FontAwesomeIcon icon={faBars} />
        //         </Button>
        //     </div>
        //     <div className="right-colum">
        //         <h2 className="d-flex align-items-center">
        //             Terms and Conditions
        //         </h2>
        //         <h3>Notices and Policies</h3>
        //     </div>
        // </div>
        <div className="label-block">
            <div className="inner">
                <Button color="link" className={location.pathname === "/terms-and-condition/cookie-notice" ? "active" : null} onClick={() => handleClick("/terms-and-condition/cookie-notice")}>Cookie Notice</Button>
                <Button color="link" className={location.pathname === "/terms-and-condition/california-privacy-disclosure" ? "active" : null} onClick={() => handleClick("/terms-and-condition/california-privacy-disclosure")}>California Privacy Disclousures</Button>
                <Button color="link" className={location.pathname === "/terms-and-condition/privacy-notice" ? "active" : null} onClick={() => handleClick("/terms-and-condition/privacy-notice")}>Privacy Notice</Button>
                <Button color="link" className={location.pathname === "/terms-and-condition/use-site" ? "active" : null} onClick={() => handleClick("/terms-and-condition/use-site")}>Site Use</Button>
                {/* <Button color="link" onClick={() => dispatch(documentLabelPanelAction(false))}>Site Use</Button> */}
            </div>
        </div>





    )
};
export default SideBar;